export function hasProp(data, prop) {
    return prop in data;
}
